export { default } from './SearchResultItem';



// WEBPACK FOOTER //
// ./app/components/search/SearchResultItem/index.js